import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { BusquedaProductosService } from '../../../utils/services/busqueda-productos.service';

@Component({
  selector: 'app-lista-marcas',
  templateUrl: './lista-marcas.component.html',
  styleUrls: ['./lista-marcas.component.scss']
})
export class ListaMarcasComponent implements OnInit {
  public marca$: Observable<any>;
  @Input() public value: string;
  public moreMarcas = 5;
  @Output() search: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private headerService: BusquedaProductosService,
  ) { }

  ngOnInit() {
    this.marca$ = this.headerService.getMarcas();
  }

  public closePanel(item: any) {
    //console.log(item)
    this.search.emit({tipo: 'marca', item});
  }
}
